import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

export interface ExternalActivityFacets {
    indications: string[]
    statuses: string[]
    sources: string[]
    therapeuticAreas: string[]
    genericNames: string[]
    studyTypes: string[]
    compoundNames: string[]
}

const THIRTY_MINUTES = 30 * 60 * 1000

export const useGetExternalActivityFacetsQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    return useQuery<ExternalActivityFacets>(
        ['externalActivityFacets'],
        async () => {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const res = await callAPI(
                endpoints.getExternalActivityFacets.url,
                endpoints.getExternalActivityFacets.method,
                token
            )
            if (!res.success && res.error) throw new Error(res.error)
            return res as ExternalActivityFacets
        },
        {
            enabled: !!getTokenSilently && !!isAuthenticated && !isLoading,
            staleTime: THIRTY_MINUTES,
            cacheTime: THIRTY_MINUTES,
            refetchOnWindowFocus: false,
            retry: 0,
        }
    )
}
